import { mf, msg } from '../message-functions'

/**
  <span style="color:#85c1dc;">**EE:**</span>
  Osta püsikliendina

  <span style="color:#85c1dc;">**FI:**</span>
  Osta ON24-asiakkaana

  <span style="color:#85c1dc;">**RU:**</span>
  Купить как постоянный клиент
*/
/* @__NO_SIDE_EFFECTS__ */
const m1322 = msg(
  mf`Osta püsikliendina`,
  mf`Osta ON24-asiakkaana`,
  mf`Купить как постоянный клиент`,
)

export { m1322 as 'w.basket.continue_as_client_mobile' }